// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/datatables.net-fixedcolumns-bs/css/fixedColumns.bootstrap.min.css
// module id = 1605
// module chunks = 0